
import React, { Suspense, lazy, useRef, useState, useContext, createContext , useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import  LeftSection  from "./layout/LeftSection";
import Chart from './chart/Chart';
import Orders from "./Home/Orders";
import { toplevelAlerts , alertDanger , customalert , loggedInCustomerDetails , alert } from "../functions/Function";

const HomeContext = createContext();

const  Home = (props) => {
  const [activeproductchart, setActiveproductchart] = useState(0); 
  const [updateOrderlist, setupdateOrderlist] = useState(false); 
  const handleClickActiveProduct = (id='') =>
  {
    setActiveproductchart(id);
  }

  const getActiveProdcutID = () =>
  {
      return  activeproductchart; 
  }
  

  const handleClickUpdateOrdersList = (arg=false) =>
  {
    setupdateOrderlist(arg);
  }

  let homecontext = { 
    handleClickUpdateOrdersList: handleClickUpdateOrdersList ,
    updateOrderlist: updateOrderlist ,
    handleClickActiveProduct:handleClickActiveProduct,
    getActiveProdcutID:getActiveProdcutID
    }
  return (
    <>
    <HomeContext.Provider value={homecontext}>
      <section className="mt-4 mb-4 ivo-main-index">
        <div className="container-fluid">
            <div className="row">
                <LeftSection 
                    handleClickActiveProduct={handleClickActiveProduct} 
                    activeproduct={activeproductchart} 
                    handleClickUpdateOrdersList={handleClickUpdateOrdersList}
                />

                <div className="col-lg-9">
                            
                    <div className="row">
                    
                      <div className="col-lg-12 mb-4">
                            <Chart activeproductchart={activeproductchart} />
                      </div>
                      



                        <div className="col-lg-6 mb-4">
                            <div className="trade-one-table-box trade-shadow-box">

                                <div className="table-tabs">
                                    <span><i className="fa-solid fa-caret-down"></i> ORDER BOOK</span>
                                    <nav className="ivo-buy-sell-tabs">
                                        <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                            <button className="ivo-buy-single nav-link active" id="nav-market-tab"
                                                data-toggle="tab" data-target="#nav-market" type="button" role="tab"
                                                aria-controls="nav-home" aria-selected="true">MARKET DEPTH</button>
                                            <button className="nav-link ivo-buy-single" id="nav-order-tab" data-toggle="tab"
                                                data-target="#nav-order" type="button" role="tab"
                                                aria-controls="nav-profile" aria-selected="false">ORDER VOLUME</button>

                                        </div>
                                    </nav>
                                </div>

                                <div className="tab-content" id="nav-tabContent">

                                    <div className="tab-pane fade show active" id="nav-market" role="tabpanel"
                                        aria-labelledby="nav-market-tab">
                                        <table className="table table-borderless trade-table">
                                            <thead>
                                                <tr className="trade-tablke-header">

                                                    <th scope="col">VOLUME</th>
                                                    <th scope="col">BUY PRICE</th>
                                                    <th scope="col">SELL PRICE</th>
                                                    <th scope="col">VOLUME</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>

                                                    <td data-label="" className="color-green">0.05000</td>
                                                    <td data-label="" className="color-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green">0.05000</td>
                                                    <td data-label="" className="color-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green">0.05000</td>
                                                    <td data-label="" className="color-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red td-red">20,49,....</td>
                                                    <td data-label="" className="color-red td-red">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red td-red">20,49,....</td>
                                                    <td data-label="" className="color-red td-red">0.02876</td>
                                                </tr>


                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="tab-pane fade " id="nav-order" role="tabpanel"
                                        aria-labelledby="nav-order-tab">
                                        <table className="table table-borderless trade-table">
                                            <thead>
                                                <tr className="trade-tablke-header">

                                                    <th scope="col">VOLUME</th>
                                                    <th scope="col">BUY PRICE</th>
                                                    <th scope="col">SELL PRICE</th>
                                                    <th scope="col">VOLUME</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>

                                                    <td data-label="" className="color-green">0.05000</td>
                                                    <td data-label="" className="color-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green">0.05000</td>
                                                    <td data-label="" className="color-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green">0.05000</td>
                                                    <td data-label="" className="color-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red">20,49,....</td>
                                                    <td data-label="">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red td-red">20,49,....</td>
                                                    <td data-label="" className="color-red td-red">0.02876</td>
                                                </tr>
                                                <tr>

                                                    <td data-label="" className="color-green td-green">0.05000</td>
                                                    <td data-label="" className="color-green td-green">20,32,....</td>
                                                    <td data-label="" className="color-red td-red">20,49,....</td>
                                                    <td data-label="" className="color-red td-red">0.02877</td>
                                                </tr>


                                            </tbody>
                                        </table>
                                    </div>






                                </div>


                            </div>

                        </div>

                        <div className="col-lg-6 mb-4">
                            <div className="trade-one-table-box trade-shadow-box">

                                <div className="table-tabs">
                                    <span><i className="fa-solid fa-caret-down"></i> TRADE HISTORY</span>

                                </div>




                                <table className="table table-borderless trade-table">
                                    <thead>
                                        <tr className="trade-tablke-header">

                                            <th scope="col">PRICE</th>
                                            <th scope="col">VOLUME</th>
                                            <th scope="col">TIME</th>
                                        </tr>
                                    </thead>
                                    <tbody>


                                        <tr>

                                            <td data-label="" className="color-green td-green">0.05000</td>
                                            <td data-label="" className=" td-green">20,32,....</td>
                                            <td data-label="" className=" td-green">20,49,....</td>

                                        </tr>
                                        <tr>

                                            <td data-label="" className="color-green td-green">0.05000</td>
                                            <td data-label="" className=" td-green">20,32,....</td>
                                            <td data-label="" className=" td-green">20,49,....</td>

                                        </tr>
                                        <tr>

                                            <td data-label="" className="color-red td-red">0.05000</td>
                                            <td data-label="" className=" td-red">20,32,....</td>
                                            <td data-label="" className=" td-red">20,49,....</td>

                                        </tr>
                                        <tr>

                                            <td data-label="" className="color-green td-green">0.05000</td>
                                            <td data-label="" className=" td-green">20,32,....</td>
                                            <td data-label="" className=" td-green">20,49,....</td>

                                        </tr>
                                        <tr>

                                            <td data-label="" className="color-green td-green">0.05000</td>
                                            <td data-label="" className=" td-green">20,32,....</td>
                                            <td data-label="" className=" td-green">20,49,....</td>

                                        </tr>
                                        <tr>

                                            <td data-label="" className="color-green td-green">0.05000</td>
                                            <td data-label="" className=" td-green">20,32,....</td>
                                            <td data-label="" className=" td-green">20,49,....</td>

                                        </tr>
                                        <tr>

                                            <td data-label="" className="color-red td-red">0.05000</td>
                                            <td data-label="" className=" td-red">20,32,....</td>
                                            <td data-label="" className=" td-red">20,49,....</td>

                                        </tr>



                                    </tbody>
                                </table>











                            </div>

                        </div>
                        <div className="col-lg-12 final-tabs mb-4">

                            <Orders updateOrderlist={updateOrderlist}/>


                        </div>
                    </div>


                </div>
            </div>
        </div>

    </section>
    </HomeContext.Provider>
    </>

  );
}

export default Home;
export { HomeContext};
